/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

export const LOAD_DASHBOARD_DATA_REQUEST = 'LOAD_DASHBOARD_DATA_REQUEST';
export const LOAD_DASHBOARD_DATA_FAILURE = 'LOAD_DASHBOARD_DATA_FAILURE';
export const LOAD_DASHBOARD_DATA_SUCCESS = 'LOAD_DASHBOARD_DATA_SUCCESS';
export const CLEAR_DASHBOARD_ERROR = 'CLEAR_DASHBOARD_ERROR';

export const GET_OTHER_SERVICES = 'GET_OTHER_SERVICES';
export const GET_OTHER_SERVICES_SUCCESS = 'GET_OTHER_SERVICES_SUCCESS';
export const GET_OTHER_SERVICES_FAILURE = 'GET_OTHER_SERVICES_FAILURE';

export const DELETE_OTHER_SERVICE = 'DELETE_OTHER_SERVICE';
export const DELETE_OTHER_SERVICE_SUCCESS = 'DELETE_OTHER_SERVICE_SUCCESS';
export const DELETE_OTHER_SERVICE_FAILURE = 'DELETE_OTHER_SERVICE_FAILURE';

export const ADD_OTHER_SERVICE = 'ADD_OTHER_SERVICE';
export const ADD_OTHER_SERVICE_SUCCESS = 'ADD_OTHER_SERVICE_SUCCESS';
export const ADD_OTHER_SERVICE_FAILURE = 'ADD_OTHER_SERVICE_FAILURE';

export const UPDATE_OTHER_SERVICE = 'UPDATE_OTHER_SERVICE';
export const UPDATE_OTHER_SERVICE_SUCCESS = 'UPDATE_OTHER_SERVICE_SUCCESS';
export const UPDATE_OTHER_SERVICE_FAILURE = 'UPDATE_OTHER_SERVICE_FAILURE';

export const OPEN_CREDENTIALS_DIALOG = 'OPEN_CREDENTIALS_DIALOG';
export const CLOSE_CREDENTIALS_DIALOG = 'CLOSE_CREDENTIALS_DIALOG';

export const LOAD_SERVICE_STATUS_REQUEST = 'LOAD_SERVICE_STATUS_REQUEST';
export const LOAD_SERVICE_STATUS_FAILURE = 'LOAD_SERVICE_STATUS_FAILURE';
export const LOAD_SERVICE_STATUS_SUCCESS = 'LOAD_SERVICE_STATUS_SUCCESS';

export const LOAD_USAGE_DATA_REQUEST = 'LOAD_USAGE_DATA_REQUEST';
export const LOAD_USAGE_DATA_FAILURE = 'LOAD_USAGE_DATA_FAILURE';
export const LOAD_USAGE_DATA_SUCCESS = 'LOAD_USAGE_DATA_SUCCESS';

// COS Actions
export const OPEN_COS_MAIN_DIALOG = 'OPEN_COS_MAIN_DIALOG';
export const CLOSE_COS_MAIN_DIALOG = 'CLOSE_COS_MAIN_DIALOG';
export const OPEN_COS_CREATE_BUCKET_DIALOG = 'OPEN_COS_CREATE_BUCKET_DIALOG';
export const CLOSE_COS_CREATE_BUCKET_DIALOG = 'CLOSE_COS_CREATE_BUCKET_DIALOG';
export const LOAD_BUCKETS_REQUEST = 'LOAD_BUCKETS_REQUEST';
export const LOAD_BUCKETS_SUCCESS = 'LOAD_BUCKETS_SUCCESS';
export const LOAD_BUCKETS_FAILURE = 'LOAD_BUCKETS_FAILURE';
export const CREATE_BUCKET_REQUEST = 'CREATE_BUCKET_REQUEST';
export const CREATE_BUCKET_SUCCESS = 'CREATE_BUCKET_SUCCESS';
export const CREATE_BUCKET_FAILURE = 'CREATE_BUCKET_FAILURE';
export const DELETE_BUCKET_REQUEST = 'DELETE_BUCKET_REQUEST';
export const DELETE_BUCKET_SUCCESS = 'DELETE_BUCKET_SUCCESS';
export const DELETE_BUCKET_FAILURE = 'DELETE_BUCKET_FAILURE';
export const ADD_BUCKET_ROW = 'ADD_BUCKET_ROW';
export const REMOVE_BUCKET_ROW = 'REMOVE_BUCKET_ROW';

export const LOAD_COS_USAGE_REQUEST = 'LOAD_COS_USAGE_REQUEST';
export const LOAD_COS_USAGE_SUCCESS = 'LOAD_COS_USAGE_SUCCESS';
export const LOAD_COS_USAGE_FAILURE = 'LOAD_COS_USAGE_FAILURE';

// BOS Bucket Actions
export const OPEN_BOS_MAIN_DIALOG = 'OPEN_BOS_MAIN_DIALOG';
export const CLOSE_BOS_MAIN_DIALOG = 'CLOSE_BOS_MAIN_DIALOG';
export const LOAD_BOS_BUCKETS_REQUEST = 'LOAD_BOS_BUCKETS_REQUEST';
export const LOAD_BOS_BUCKETS_SUCCESS = 'LOAD_BOS_BUCKETS_SUCCESS';
export const LOAD_BOS_BUCKETS_FAILURE = 'LOAD_BOS_BUCKETS_FAILURE';
export const CREATE_BOS_BUCKET_REQUEST = 'CREATE_BOS_BUCKET_REQUEST';
export const CREATE_BOS_BUCKET_SUCCESS = 'CREATE_BOS_BUCKET_SUCCESS';
export const CREATE_BOS_BUCKET_FAILURE = 'CREATE_BOS_BUCKET_FAILURE';
export const DELETE_BOS_BUCKET_REQUEST = 'DELETE_BOS_BUCKET_REQUEST';
export const DELETE_BOS_BUCKET_SUCCESS = 'DELETE_BOS_BUCKET_SUCCESS';
export const DELETE_BOS_BUCKET_FAILURE = 'DELETE_BOS_BUCKET_FAILURE';
export const ADD_BOS_BUCKET_ROW = 'ADD_BOS_BUCKET_ROW';
export const REMOVE_BOS_BUCKET_ROW = 'REMOVE_BOS_BUCKET_ROW';

export const LOAD_IOT4E_USAGE_REQUEST = 'LOAD_IOT4E_USAGE_REQUEST';
export const LOAD_IOT4E_USAGE_SUCCESS = 'LOAD_IOT4E_USAGE_SUCCESS';
export const LOAD_IOT4E_USAGE_FAILURE = 'LOAD_IOT4E_USAGE_FAILURE';

export const OPEN_MSGHUB_MAIN_DIALOG = 'OPEN_MSGHUB_MAIN_DIALOG';
export const CLOSE_MSGHUB_MAIN_DIALOG = 'CLOSE_MSGHUB_MAIN_DIALOG';
export const OPEN_MSGHUB_CREATE_TOPIC_DIALOG = 'OPEN_MSGHUB_CREATE_TOPIC_DIALOG';
export const CLOSE_MSGHUB_CREATE_TOPIC_DIALOG = 'CLOSE_MSGHUB_CREATE_TOPIC_DIALOG';
export const LOAD_TOPICS_REQUEST = 'LOAD_TOPICS_REQUEST';
export const LOAD_TOPICS_SUCCESS = 'LOAD_TOPICS_SUCCESS';
export const LOAD_TOPICS_FAILURE = 'LOAD_TOPICS_FAILURE';
export const CREATE_TOPIC_REQUEST = 'CREATE_TOPIC_REQUEST';
export const CREATE_TOPIC_SUCCESS = 'CREATE_TOPIC_SUCCESS';
export const CREATE_TOPIC_FAILURE = 'CREATE_TOPIC_FAILURE';
export const DELETE_TOPIC_REQUEST = 'DELETE_TOPIC_REQUEST';
export const DELETE_TOPIC_SUCCESS = 'DELETE_TOPIC_SUCCESS';
export const DELETE_TOPIC_FAILURE = 'DELETE_TOPIC_FAILURE';
export const STREAM_MIGRATION_REQUEST = 'STREAM_MIGRATION_REQUEST';
export const STREAM_MIGRATION_SUCCESS = 'STREAM_MIGRATION_SUCCESS';
export const STREAM_MIGRATION_FAILURE = 'STREAM_MIGRATION_FAILURE';
export const STATUS_STREAM_MIGRATION_REQUEST = 'STATUS_STREAM_MIGRATION_REQUEST';
export const STATUS_STREAM_MIGRATION_SUCCESS = 'STATUS_STREAM_MIGRATION_SUCCESS';
export const STATUS_STREAM_MIGRATION_FAILURE = 'STATUS_STREAM_MIGRATION_FAILURE';
export const COMPLETE_STREAM_MIGRATION_REQUEST = 'COMPLETE_STREAM_MIGRATION_REQUEST';
export const COMPLETE_STREAM_MIGRATION_SUCCESS = 'COMPLETE_STREAM_MIGRATION_SUCCESS';
export const COMPLETE_STREAM_MIGRATION_FAILURE = 'COMPLETE_STREAM_MIGRATION_FAILURE';
export const ADD_TOPIC_ROW = 'ADD_TOPIC_ROW';
export const REMOVE_TOPIC_ROW = 'REMOVE_TOPIC_ROW';

// SAMPLE APP ACTION  -> reducers
export const LOAD_SAMPLE_APP_DETAILS_REQUEST = 'LOAD_SAMPLE_APP_DETAILS_REQUEST';
export const LOAD_SAMPLE_APP_DETAILS_SUCCESS = 'LOAD_SAMPLE_APP_DETAILS_SUCCESS';
export const LOAD_SAMPLE_APP_DETAILS_FAILURE = 'LOAD_SAMPLE_APP_DETAILS_FAILURE';

export const LOAD_STARTER_APP_LOGS_REQUEST = 'LOAD_STARTER_APP_LOGS_REQUEST';
export const LOAD_STARTER_APP_LOGS_SUCCESS = 'LOAD_STARTER_APP_LOGS_SUCCESS';
export const LOAD_STARTER_APP_LOGS_FAILURE = 'LOAD_STARTER_APP_LOGS_FAILURE';

/*
 * Factory Talk Actions
 */
export const GET_MONITOR_DB_SCHEMAS_REQUEST = 'GET_MONITOR_DB_SCHEMAS_REQUEST';
export const GET_MONITOR_DB_SCHEMAS_SUCCESS = 'GET_MONITOR_DB_SCHEMAS_SUCCESS';
export const GET_MONITOR_DB_SCHEMAS_FAILURE = 'GET_MONITOR_DB_SCHEMAS_FAILURE';

export const GET_FACTORYTALK_SOURCE_TABLES_REQUEST = 'GET_FACTORYTALK_SOURCE_TABLES_REQUEST';
export const GET_FACTORYTALK_SOURCE_TABLES_SUCCESS = 'GET_FACTORYTALK_SOURCE_TABLES_SUCCESS';
export const GET_FACTORYTALK_SOURCE_TABLES_FAILURE = 'GET_FACTORYTALK_SOURCE_TABLES_FAILURE';

export const GET_FACTORYTALK_SOURCE_TABLES_TAGS_REQUEST =
  'GET_FACTORYTALK_SOURCE_TABLES_TAGS_REQUEST';
export const GET_FACTORYTALK_SOURCE_TABLES_TAGS_SUCCESS =
  'GET_FACTORYTALK_SOURCE_TABLES_TAGS_SUCCESS';
export const GET_FACTORYTALK_SOURCE_TABLES_TAGS_FAILURE =
  'GET_FACTORYTALK_SOURCE_TABLES_TAGS_FAILURE';

export const GET_FACTORYTALK_SERVICE_CONFIGURATIONS_REQUEST =
  'GET_FACTORYTALK_SERVICE_CONFIGURATIONS_REQUEST';
export const GET_FACTORYTALK_SERVICE_CONFIGURATIONS_SUCCESS =
  'GET_FACTORYTALK_SERVICE_CONFIGURATIONS_SUCCESS';
export const GET_FACTORYTALK_SERVICE_CONFIGURATIONS_FAILURE =
  'GET_FACTORYTALK_SERVICE_CONFIGURATIONS_FAILURE';

export const UPDATE_FACTORYTALK_SERVICE_CONFIGURATION_REQUEST =
  'UPDATE_FACTORYTALK_SERVICE_CONFIGURATION_REQUEST';
export const UPDATE_FACTORYTALK_SERVICE_CONFIGURATION_SUCCESS =
  'UPDATE_FACTORYTALK_SERVICE_CONFIGURATION_SUCCESS';
export const UPDATE_FACTORYTALK_SERVICE_CONFIGURATION_FAILURE =
  'UPDATE_FACTORYTALK_SERVICE_CONFIGURATION_FAILURE';

export const CREATE_FACTORYTALK_SERVICE_CONFIGURATION_REQUEST =
  'CREATE_FACTORYTALK_SERVICE_CONFIGURATION_REQUEST';
export const CREATE_FACTORYTALK_SERVICE_CONFIGURATION_SUCCESS =
  'CREATE_FACTORYTALK_SERVICE_CONFIGURATION_SUCCESS';
export const CREATE_FACTORYTALK_SERVICE_CONFIGURATION_FAILURE =
  'CREATE_FACTORYTALK_SERVICE_CONFIGURATION_FAILURE';

export const DELETE_FACTORYTALK_SERVICE_CONFIGURATION_REQUEST =
  'DELETE_FACTORYTALK_SERVICE_CONFIGURATION_REQUEST';
export const DELETE_FACTORYTALK_SERVICE_CONFIGURATION_SUCCESS =
  'DELETE_FACTORYTALK_SERVICE_CONFIGURATION_SUCCESS';
export const DELETE_FACTORYTALK_SERVICE_CONFIGURATION_FAILURE =
  'DELETE_FACTORYTALK_SERVICE_CONFIGURATION_FAILURE';

export const GET_FACTORYTALK_VALIDATE_DATABASE_CONNECTION_REQUEST =
  'GET_FACTORYTALK_VALIDATE_DATABASE_CONNECTION_REQUEST';
export const GET_FACTORYTALK_VALIDATE_DATABASE_CONNECTION_SUCCESS =
  'GET_FACTORYTALK_VALIDATE_DATABASE_CONNECTION_SUCCESS';
export const GET_FACTORYTALK_VALIDATE_DATABASE_CONNECTION_FAILURE =
  'GET_FACTORYTALK_VALIDATE_DATABASE_CONNECTION_FAILURE';

export const GET_FACTORYTALK_ENTITY_TYPE_NAMES_REQUEST =
  'GET_FACTORYTALK_ENTITY_TYPE_NAMES_REQUEST';
export const GET_FACTORYTALK_ENTITY_TYPE_NAMES_SUCCESS =
  'GET_FACTORYTALK_ENTITY_TYPE_NAMES_SUCCESS';
export const GET_FACTORYTALK_ENTITY_TYPE_NAMES_FAILURE =
  'GET_FACTORYTALK_ENTITY_TYPE_NAMES_FAILURE';

export const GET_SERVICE_CONFIG_FILE_REQUEST = 'GET_SERVICE_CONFIG_FILE_REQUEST';
export const GET_SERVICE_CONFIG_FILE_SUCCESS = 'GET_SERVICE_CONFIG_FILE_SUCCESS';
export const GET_SERVICE_CONFIG_FILE_FAILURE = 'GET_SERVICE_CONFIG_FILE_FAILURE';

export const GET_SERVICE_CONFIG_FILE_NAMES_REQUEST = 'GET_SERVICE_CONFIG_FILE_NAMES_REQUEST';
export const GET_SERVICE_CONFIG_FILE_NAMES_SUCCESS = 'GET_SERVICE_CONFIG_FILE_NAMES_SUCCESS';
export const GET_SERVICE_CONFIG_FILE_NAMES_FAILURE = 'GET_SERVICE_CONFIG_FILE_NAMES_FAILURE';

export const UPLOAD_SERVICE_CONFIG_FILES_REQUEST = 'UPLOAD_SERVICE_CONFIG_FILES_REQUEST';
export const UPLOAD_SERVICE_CONFIG_FILES_SUCCESS = 'UPLOAD_SERVICE_CONFIG_FILES_SUCCESS';
export const UPLOAD_SERVICE_CONFIG_FILES_FAILURE = 'UPLOAD_SERVICE_CONFIG_FILES_FAILURE';

export const DELETE_SERVICE_CONFIG_FILES_REQUEST = 'DELETE_SERVICE_CONFIG_FILES_REQUEST';
export const DELETE_SERVICE_CONFIG_FILES_SUCCESS = 'DELETE_SERVICE_CONFIG_FILES_SUCCESS';
export const DELETE_SERVICE_CONFIG_FILES_FAILURE = 'DELETE_SERVICE_CONFIG_FILES_FAILURE';
